/* Books page: find the 5 hidden Bobs, same game as Play & Learn, with a big finish.
   Each find: sparkle pop where you clicked, counter shake.
   All 5: corner confetti cannons, firework bursts, a confetti downpour, and a celebration card.
   Loaded by templates/collection.books.liquid. Sticker image URLs come from data attributes on #shopBob. */
(function () {
  var root = document.getElementById('shopBob');
  if (!root) return;
  var bobs = root.querySelectorAll('[data-hidden-bob]');
  if (!bobs.length) return;
  var total = bobs.length, found = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLS = ['#38b6ff', '#ff3131', '#cb6ce6', '#ff66c4', '#ffd84d', '#7fd8be', '#ffffff'];
  var K = window.innerWidth < 700 ? 0.5 : 1; /* fewer pieces on phones so the card stays smooth */
  function n(x) { return Math.max(8, Math.round(x * K)); }

  var icon = '<svg viewBox="0 0 48 48" width="26" height="26" style="display:block;flex-shrink:0" aria-hidden="true"><path d="M24,13 L24,9 C24,6 20,6.5 21.5,9.5 C23,12 27,9 25,6 C24,4.5 22.5,4 21,5" fill="none" stroke="#232350" stroke-width="1.6" stroke-linecap="round"/><path d="M24,12 C34,12 43,18 43,27 C43,36 35,42 24,42 C13,42 5,36 5,27 C5,18 14,12 24,12 Z" fill="#bfe3ff" stroke="#232350" stroke-width="2.4"/><circle cx="15" cy="25" r="6" fill="#fff" stroke="#232350" stroke-width="1.6"/><circle cx="33" cy="24" r="6" fill="#fff" stroke="#232350" stroke-width="1.6"/><circle cx="16" cy="27" r="3" fill="#232350"/><circle cx="32" cy="26" r="3" fill="#232350"/><path d="M18,34 Q24,38 30,34" fill="none" stroke="#232350" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var counter = document.createElement('div');
  counter.className = 'bk-counter';
  counter.setAttribute('role', 'status');
  counter.innerHTML = icon + '<span class="bk-counter-txt">Bobs found: 0/' + total + '</span>';
  document.body.appendChild(counter);
  var txt = counter.querySelector('.bk-counter-txt');

  /* One particle that flies from (x,y) by (dx,dy). The reflow before moving is what makes the animation actually play. */
  function particle(x, y, dx, dy, opts) {
    var o = opts || {};
    var p = document.createElement('div');
    var sz = o.size || (10 + Math.random() * 10);
    var h = o.streamer ? sz * 3.2 : sz;
    var dur = o.dur || (2.2 + Math.random() * 1.2);
    var col = o.color || COLS[(Math.random() * COLS.length) | 0];
    p.style.cssText = 'position:fixed;left:' + x + 'px;top:' + y + 'px;width:' + sz + 'px;height:' + h + 'px;margin:' + (-h / 2) + 'px 0 0 ' + (-sz / 2) + 'px;z-index:9600;pointer-events:none;border-radius:' + (o.round || o.glow ? '50%' : (o.streamer ? '3px' : (Math.random() > .5 ? '50%' : '4px'))) + ';background:' + col + ';' + (o.glow ? 'box-shadow:0 0 10px 3px ' + col + ';' : 'box-shadow:0 1px 2px rgba(35,35,80,.2);') + 'opacity:1;transform:translate(0,0) rotate(0deg);will-change:transform,opacity';
    document.body.appendChild(p);
    p.getBoundingClientRect(); /* commit the start state */
    var fall = o.gravity ? o.gravity : 0;
    p.style.transition = 'transform ' + dur + 's cubic-bezier(.12,.62,.28,1),opacity ' + dur + 's ease-in';
    p.style.transform = 'translate(' + dx + 'px,' + (dy + fall) + 'px) rotate(' + (Math.random() * 1080 - 540) + 'deg)';
    p.style.opacity = '0';
    setTimeout(function () { p.remove(); }, dur * 1000 + 150);
  }

  function pop(x, y) { /* small sparkle burst on each find */
    if (reduce) return;
    for (var i = 0; i < 26; i++) {
      var a = Math.random() * Math.PI * 2, d = 50 + Math.random() * 90;
      particle(x, y, Math.cos(a) * d, Math.sin(a) * d, { size: 7 + Math.random() * 6, dur: .9 + Math.random() * .5, gravity: 30 });
    }
  }

  function cannon(x, y, dirX, count) { /* confetti shot up and inward from a corner */
    count = n(count);
    for (var i = 0; i < count; i++) {
      var spread = window.innerWidth * (.35 + Math.random() * .45);
      particle(x, y, dirX * spread, -(window.innerHeight * (.55 + Math.random() * .45)), { size: 12 + Math.random() * 14, streamer: i % 4 === 0, dur: 2.6 + Math.random() * 1.4, gravity: window.innerHeight * .35 });
    }
  }

  function firework(x, y) { /* round glowing burst */
    var col = COLS[(Math.random() * 5) | 0], m = n(42);
    for (var i = 0; i < m; i++) {
      var a = (i / m) * Math.PI * 2 + Math.random() * .12, d = 110 + Math.random() * 90;
      particle(x, y, Math.cos(a) * d, Math.sin(a) * d, { size: 6 + Math.random() * 3, glow: true, color: i % 3 === 0 ? '#ffffff' : col, dur: 1.4 + Math.random() * .5, gravity: 60 });
    }
  }

  function downpour() {
    for (var i = 0, dn = n(90); i < dn; i++) {
      (function (i) {
        setTimeout(function () {
          particle(Math.random() * window.innerWidth, -20, (Math.random() - .5) * 220, window.innerHeight + 60, { size: 10 + Math.random() * 12, streamer: i % 5 === 0, dur: 2.8 + Math.random() * 1.6 });
        }, i * 28);
      })(i);
    }
  }

  function showCard() {
    if (document.querySelector('.bk-win')) return;
    var sr = root.getAttribute('data-sticker-reading'), sh = root.getAttribute('data-sticker-heart');
    var wrap = document.createElement('div');
    wrap.className = 'bk-win';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'You found all 5 Bobs');
    wrap.innerHTML =
      '<div class="bk-win-card">' +
        (sr ? '<img class="bk-win-st bk-win-st--l" src="' + sr + '" alt="">' : '') +
        (sh ? '<img class="bk-win-st bk-win-st--r" src="' + sh + '" alt="">' : '') +
        '<div class="bk-win-eyebrow">Bob Squad hero</div>' +
        '<div class="bk-win-title">You found all <span class="bk-win-5">5</span> Bobs!</div>' +
        '<p class="bk-win-text">Bob is SO proud of you. Sharp eyes, big heart. That is the Bob Squad way.</p>' +
        '<button type="button" class="bk-win-btn">Yay! Keep exploring</button>' +
      '</div>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-on'); });
    function close() { wrap.classList.remove('is-on'); setTimeout(function () { wrap.remove(); }, 350); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    wrap.querySelector('.bk-win-btn').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    wrap.querySelector('.bk-win-btn').focus({ preventScroll: true });
  }

  function celebrate() {
    showCard();
    if (reduce) return;
    var w = window.innerWidth, h = window.innerHeight;
    cannon(10, h - 10, 1, 70);
    cannon(w - 10, h - 10, -1, 70);
    var spots = [[.22, .28], [.78, .26], [.5, .18], [.32, .5], [.68, .48], [.15, .62], [.85, .6], [.5, .38]];
    spots.forEach(function (s, i) { setTimeout(function () { firework(w * s[0], h * s[1]); }, 250 + i * 280); });
    setTimeout(downpour, 500);
    setTimeout(function () { cannon(10, h - 10, 1, 50); cannon(w - 10, h - 10, -1, 50); }, 1700);
  }

  for (var i = 0; i < bobs.length; i++) {
    bobs[i].addEventListener('click', function (e) {
      var r = this.getBoundingClientRect();
      pop(r.left + r.width / 2, r.top + r.height / 2);
      this.style.display = 'none';
      counter.style.animation = 'none'; void counter.offsetWidth; counter.style.animation = 'bkShake .6s ease';
      found = Math.min(total, found + 1);
      if (found === total) {
        txt.textContent = 'All ' + total + ' Bobs found! 🎉';
        counter.classList.add('is-done');
        setTimeout(celebrate, 250);
      } else {
        txt.textContent = 'Bobs found: ' + found + '/' + total;
      }
    });
  }
})();
